import * as React from "react"

const ObjectsPortal = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 397.12 204.46"
    {...props}
  >
    <defs>
      <radialGradient
        id="gradient1"
        cx={188.18}
        cy={113.59}
        r={42.42}
        gradientTransform="matrix(1 0 0 -1 0 206)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#dcefe9" />
        <stop offset={1} stopColor="#4ead90" />
      </radialGradient>
    </defs>
    <title>{"about-objects-through-portal-3"}</title>
    <path
      d="m218.14 204.45-39.51-61.9V0l39.51 61.9Zm-30.48-64.54 21.46 33.62v-109l-21.46-33.61Z"
      fill="#3e4c5e"
    />
    <path
      fill="#4ead90"
      d="m243.99 65.17 20.84 36.11h41.7l-20.85-36.11h-41.69z"
    />
    <path
      fill="#317d6e"
      d="M306.53 29.06h-41.7l-20.84 36.11h41.69l20.85-36.11z"
    />
    <path
      fill="#b9d816"
      d="m306.48 29.06 20.8 36.11-20.8 36.11-20.8-36.11 20.8-36.11z"
    />
    <path
      fill="#4ead90"
      d="m355.27 83.27-6.47 24.16 17.69 17.69 6.47-24.16-17.69-17.69z"
    />
    <path
      fill="#317d6e"
      d="m397.12 94.48-17.68-17.69-24.17 6.48 17.69 17.69 24.16-6.48z"
    />
    <path
      fill="#b9d816"
      d="m397.1 94.46-6.49 24.15-24.15 6.49 6.5-24.14 24.14-6.5z"
    />
    <path
      fill="#4ead90"
      d="m112.36 180.35 36.1-20.85.01-41.69-36.11 20.84v41.7z"
    />
    <path
      fill="#317d6e"
      d="M76.25 117.81v41.69l36.11 20.85v-41.7l-36.11-20.84z"
    />
    <path
      fill="#b9d816"
      d="m76.25 117.86 36.11-20.8 36.11 20.8-36.11 20.79-36.11-20.79z"
    />
    <path fill="#317d6e" d="m0 102.91 12.51 21.67h25.02l-12.51-21.67H0z" />
    <path fill="#b9d816" d="M37.53 81.25H12.51L0 102.91h25.02l12.51-21.66z" />
    <path
      fill="#4ead90"
      d="m37.5 81.25 12.48 21.66-12.48 21.67-12.48-21.67L37.5 81.25z"
    />
    <circle cx={198.34} cy={101.95} r={38.57} fill="url(#gradient1)" />
    <path
      fill="#3e4c5e"
      d="m218.15 204.46-38.82-60.8 7.62-4.86 22.17 34.73V64.54l-29.79-46.65 7.62-4.86 31.2 48.88v142.55z"
    />
  </svg>
)

export default ObjectsPortal
